var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "218.8%",
    height: "218.8%",
    x: "-59.4%",
    y: "-55.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "155.2%",
    height: "155.2%",
    x: "-27.6%",
    y: "-23.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.228270343 0 0 0 0 0.730820982 0 0 0 0 0.815667194 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "193.8%",
    height: "193.8%",
    x: "-46.9%",
    y: "-46.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.411405267 0 0 0 0 0.827142459 0 0 0 0 0.906330496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "55.418%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#94DBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#58B7CB"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 23.571,
    cy: 23.571,
    r: 23.571
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    transform: "translate(10.663 8.948)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#686868",
    points: "3.006 23.324 1.505 25.581 2.255 25.581 5.267 23.377"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#686868",
    points: "22.575 23.324 24.076 25.581 23.326 25.581 20.314 23.377"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.777,
    cy: 6.979,
    fill: "#686868",
    rx: 1,
    ry: 2.956,
    transform: "rotate(-88.81 15.777 6.979)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED4F4F",
    d: "M22.1756651,23.8020248 L22.1756651,23.8020248 C15.9214974,24.1678105 9.65181519,24.1678105 3.39764755,23.8020248 L3.39764755,23.8020248 C1.52766997,23.8020248 0,22.3067566 0,20.4774391 L0,8.9964835 C0.0321390789,8.01872719 0.78836726,7.22505751 1.74870288,7.16120085 L1.94430723,7.14728213 C9.16870578,6.64620914 16.4182992,6.64620914 23.6426977,7.14728213 L23.6426977,7.14728213 C24.7073698,7.21918551 25.5453043,8.09934047 25.5811368,9.18339203 L25.5811368,20.4774391 C25.5733126,22.3067566 24.0436866,23.8020248 22.1756651,23.8020248 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA3F3F",
    d: "M19.708224,22.2626777 L19.708224,22.2626777 C13.8375226,22.6745625 7.94513224,22.6745625 2.0744308,22.2626777 L2.0744308,22.2626777 C1.49521861,22.2626777 1.01857525,21.7141691 1.01857525,21.0410909 L1.01857525,20.9366131 C0.663656752,17.2703597 0.663656752,13.5784476 1.01857525,9.91219419 L1.01857525,9.87000123 C1.08092101,9.23509757 1.52136361,8.74083713 2.07040849,8.69060741 L2.07040849,8.69060741 C7.93533213,8.13813105 13.8392781,8.13813105 19.7042017,8.69060741 L19.7042017,8.69060741 C20.2854251,8.74485551 20.7600573,9.34158458 20.7600573,10.016672 L20.7600573,10.016672 C21.1636205,13.610932 21.1690162,17.2387022 20.7761465,20.8341444 L20.7600573,20.9647417 C20.7640796,21.63782 20.2894474,22.2164663 19.708224,22.2626777 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M23.0552855 12.3068914C22.5770881 12.3068914 22.1459771 12.0188323 21.9629789 11.5770355 21.7799807 11.1352387 21.8811336 10.6267086 22.2192702 10.288572 22.5574069 9.95043536 23.065937 9.84928243 23.5077338 10.0322807 23.9495305 10.2152789 24.2375897 10.6463899 24.2375897 11.1245873 24.2366686 11.7771739 23.7078722 12.3059704 23.0552855 12.3068914L23.0552855 12.3068914ZM23.0552855 15.2626951C22.5770881 15.2626951 22.1459771 14.9746359 21.9629789 14.5328391 21.7799807 14.0910423 21.8811336 13.5825122 22.2192702 13.2443756 22.5574069 12.906239 23.065937 12.8050861 23.5077338 12.9880843 23.9495305 13.1710825 24.2375897 13.6021935 24.2375897 14.0803909 24.2366686 14.7329776 23.7078722 15.261774 23.0552855 15.2626951L23.0552855 15.2626951Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.055,
    cy: 11.125,
    r: 1,
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.055,
    cy: 14.08,
    r: 1,
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M24.5162686 19.5978737 22.2412164 19.5978737C22.1437354 19.5984257 22.05006 19.5591486 21.9809376 19.4887358 21.9118153 19.4183229 21.8729468 19.3225858 21.8729468 19.2227284L21.8729468 19.2227284C21.8724044 19.1225084 21.9110275 19.0262305 21.9802096 18.9553631 22.0493916 18.8844957 22.1433798 18.8449318 22.2412164 18.8454873L24.5162686 18.8454873C24.6137512 18.8454873 24.7072116 18.8853027 24.7759499 18.956109 24.8446882 19.0269152 24.8830312 19.1228726 24.8824923 19.2227284L24.8824923 19.2227284C24.8824923 19.4299122 24.7185252 19.5978737 24.5162686 19.5978737L24.5162686 19.5978737ZM24.516273 20.7443672 22.2412121 20.7443672C22.0378248 20.7443672 21.8729468 20.5759398 21.8729468 20.3681741L21.8729468 20.3681741C21.8729468 20.1604083 22.0378248 19.9919809 22.2412121 19.9919809L24.516273 19.9919809C24.7188608 19.9931306 24.8824923 20.1612217 24.8824923 20.3681741L24.8824923 20.3681741C24.8824923 20.5751264 24.7188608 20.7432175 24.516273 20.7443672L24.516273 20.7443672ZM24.5162686 18.4513802 22.2412164 18.4513802C22.1437354 18.4519322 22.05006 18.4126551 21.9809376 18.3422422 21.9118153 18.2718294 21.8729468 18.1760922 21.8729468 18.0762349L21.8729468 18.0762349C21.8724044 17.9760148 21.9110275 17.879737 21.9802096 17.8088696 22.0493916 17.7380022 22.1433798 17.6984382 22.2412164 17.6989938L24.5162686 17.6989938C24.6137512 17.6989938 24.7072116 17.7388092 24.7759499 17.8096154 24.8446882 17.8804216 24.8830312 17.9763791 24.8824923 18.0762349L24.8824923 18.0762349C24.8824923 18.2834187 24.7185252 18.4513802 24.5162686 18.4513802L24.5162686 18.4513802ZM24.4625268 17.3048867 22.1874745 17.3048867C22.0899935 17.3054387 21.9963181 17.2661616 21.9271958 17.1957487 21.8580734 17.1253359 21.8192049 17.0295987 21.8192049 16.9297414L21.8192049 16.9297414C21.8186626 16.8295213 21.8572856 16.7332435 21.9264677 16.6623761 21.9956497 16.5915087 22.0896379 16.5519447 22.1874745 16.5525003L24.4625268 16.5525003C24.5600093 16.5525003 24.6534697 16.5923157 24.722208 16.6631219 24.7909463 16.7339281 24.8292893 16.8298856 24.8287504 16.9297414L24.8287504 16.9297414C24.8287504 17.0292345 24.7901611 17.1246527 24.721482 17.195005 24.6528028 17.2653573 24.5596538 17.3048867 24.4625268 17.3048867L24.4625268 17.3048867Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M19.1078119,21.5440819 L19.1078119,21.5440819 C13.8905507,21.9109126 8.65419625,21.9109126 3.43693499,21.5440819 L3.43693499,21.5440819 C2.92048596,21.5440819 2.49865355,21.0523267 2.49865355,20.451513 L2.48879766,20.3563345 C2.17668764,17.075386 2.17998823,13.7717988 2.49865355,10.4914879 L2.49865355,10.4538131 C2.51963603,9.92282055 2.91104336,9.48091106 3.43299263,9.39891893 L3.43299263,9.39891893 C8.64508987,8.90520905 13.8917723,8.90520905 19.1038696,9.39891893 L19.1038696,9.39891893 C19.6203186,9.44650815 20.042151,9.97990387 20.042151,10.5886492 L20.042151,10.5886492 C20.4005192,13.8051392 20.4051466,17.0515771 20.0559493,20.2690877 L20.042151,20.3860778 C20.0460934,20.9809429 19.624261,21.50839 19.1078119,21.5440819 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M20.0643522,10.5890422 L20.0643522,10.5890422 C20.0643522,9.99422431 19.6785867,9.45095726 19.2048067,9.39940637 L19.2048067,9.39940637 C16.8190529,9.15222647 14.430178,9.02863652 12.038182,9.02863652 L12.038182,21.8192049 C14.4276811,21.8192049 16.816556,21.7273386 19.2048067,21.5436059 L19.2048067,21.5436059 C19.6785867,21.5079169 20.0643522,20.9844771 20.0643522,20.3817282 L20.0774608,20.2647474 C20.3977456,17.0481773 20.3933512,13.8046262 20.0643522,10.5890422 L20.0643522,10.5890422 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M13.736575,2.27280634 L13.736575,2.27280634 C13.885056,2.22457719 14.0495046,2.29151659 14.1056927,2.42305694 L15.7825413,6.42723561 C15.8367052,6.55944742 15.7615286,6.70587734 15.6138018,6.75590881 L15.6138018,6.75590881 C15.4658877,6.80401219 15.3020776,6.73694951 15.2467934,6.6056582 L13.5593986,2.59960141 C13.5338579,2.53535795 13.5382084,2.46469014 13.5714824,2.4033175 C13.6047564,2.34194486 13.6641945,2.29495711 13.736575,2.27280634 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M19.3838595,0.0237143883 L19.3838595,0.0237143883 C19.5358871,0.0855700077 19.6035404,0.244009378 19.535714,0.379347101 L16.3802678,6.61279825 C16.3103045,6.74722824 16.1319027,6.80773259 15.9783002,6.74912413 L15.9783002,6.74912413 C15.8262726,6.68726851 15.7586193,6.52882914 15.8264457,6.39349141 L18.9818919,0.152137312 C19.0551207,0.0207344077 19.2326331,-0.0359782509 19.3838595,0.0237143883 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbIcon);
export default __webpack_public_path__ + "static/media/VB-icon.daa118f2a2c33a4bd0d244d1067e1d8d.svg";
export { ForwardRef as ReactComponent };